import React from 'react';

const ModalFooter = ({children, className}) => {
    return (
        <div className={["flex justify-end gap-2 px-3 py-3 border-t border-gray-300 bg-[#F2F2F2] rounded-b-lg", className].join(" ")}>
            {children}
        </div>
    );
};

export default ModalFooter;